import { Heading, VStack } from '@chakra-ui/react'
import { Section } from 'commons/components/layout/Section'
import { FontFamily, TextColors } from 'commons/design-system/tokens'
import type { ReactNode } from 'react'

type Props = {
	title: string
	children: ReactNode
}

export const InfoCard = ({ title, children }: Props) => {
	return (
		<Section py={6} px={6} borderRadius={'26px'}>
			<VStack align='stretch' gap={4}>
				<Heading
					as='h2'
					fontFamily={FontFamily.DEGULAR}
					fontWeight={700}
					fontSize='18px'
					color={TextColors.PRIMARY}
					textAlign='left'
				>
					{title}
				</Heading>
				{children}
			</VStack>
		</Section>
	)
}
